import { Title } from "@/components/ui/typography";
import Link from "next/link";
import { ChevronRight } from "lucide-react";
import ParallaxSection, { ParallaxWithFramer } from "@/components/Parallax";
import Animate from "@/components/Animate";
import AboutCardContent from "@/components/aboutCardContent";
import { cmsUrl } from "../config";

export default function ApartSection({ homePage }) {
  return (
    <>
      <Animate animation="fadeInUp">
        <div className='text-center mx-auto mb-[62px]'>
          <Title
            size="xxl"
            className="text-center text-[32px] mb-2 md:mb-[6.4px] lg:mb-[12px] leading-[120%] md:leading-[115%] lg:leading-[120%]"
          >
            {homePage?.title}
          </Title>
          <Link
            href={homePage?.link !== null ? `${homePage?.Link}` : "/"}
            className="items-center text-center text-system-primary hoverunderline hoverunderline-blue inline-flex"
          >
            {homePage?.subtitle}
            <ChevronRight className="h-[20px] w-[20px]" />
          </Link>
        </div>
      </Animate>

      {homePage && (
        <ParallaxWithFramer
          threshold={[0.5, 0.9]}
          className="overflow-hidden lg:h-[680px]   xl:h-[40.22vw] "
        >
          <div className="w-full   lg:h-[680px]   xl:h-[40.22vw]  overflow-hidden">
            <div className="flex flex-col lg:flex-row h-full">
              <Link
                href={
                  homePage?.cards[0]?.link !== null
                    ? `${homePage?.cards[0]?.link}`
                    : "/"
                }
                className="relative about-card   h-[345px] md:h-[384px]  lg:h-full lg:basis-[590px]  xl:basis-[40.97vw] overflow-hidden"
              >
                <AboutCardContent
                  variant="lg"
                  title={homePage?.cards[0] ? homePage?.cards[0].title : ""}
                  content={
                    homePage?.cards[0] ? homePage?.cards[0]["sub title"] : ""
                  }
                  src={`${cmsUrl}${
                    homePage?.cards[0] && homePage?.cards[0].image?.url
                      ? homePage?.cards[0].image?.url
                      : ""
                  }`}
                />
              </Link>

              <div className="  md:basis-full lg:basis-[425px] xl:basis-[29.51vw] flex flex-col   md:flex-row lg:flex-col">
                <Link
                  href={
                    homePage?.cards[1]?.link !== null
                      ? `${homePage?.cards[1]?.link}`
                      : "/"
                  }
                  className="relative about-card  h-[345px]  md:h-[255px] lg:h-[425px]  md:basis-1/2 lg:basis-full"
                >
                  <AboutCardContent
                    theme="dark"
                    variant="sm"
                    title={homePage?.cards[1] ? homePage?.cards[1].title : ""}
                    content={
                      homePage?.cards[1] ? homePage?.cards[1]["sub title"] : ""
                    }
                    src={` ${cmsUrl}${
                      homePage?.cards[1] && homePage?.cards[1].image?.url
                        ? homePage?.cards[1].image?.url
                        : ""
                    }`}
                  />
                </Link>

                <Link
                  href={
                    homePage?.cards[2]?.link !== null
                      ? `${homePage?.cards[2]?.link}`
                      : "/"
                  }
                  className="relative about-card  flex-grow h-[345px] md:h-[255px] md:basis-1/2 lg:basis-full "
                >
                  <AboutCardContent
                    variant="sm"
                    title={homePage?.cards[2] ? homePage?.cards[2].title : ""}
                    content={
                      homePage?.cards[2] ? homePage?.cards[2]["sub title"] : ""
                    }
                    src={`${cmsUrl}${
                      homePage?.cards[2] && homePage?.cards[2].image?.url
                        ? homePage?.cards[2].image?.url
                        : ""
                    }`}
                  />
                </Link>
              </div>

              <div className=" md:basis-full lg:basis-[425px]  xl:basis-[29.51vw] flex flex-col  md:flex-row lg:flex-col">
                <Link
                  href={
                    homePage?.cards[3]?.link !== null
                      ? `${homePage?.cards[3]?.link}`
                      : "/"
                  }
                  className="relative about-card  h-[345px] md:h-[255px] lg:h-[425px]  md:basis-1/2 lg:basis-full  "
                >
                  <AboutCardContent
                    title={homePage?.cards[3] ? homePage?.cards[3].title : ""}
                    content={
                      homePage?.cards[3] ? homePage?.cards[3]["sub title"] : ""
                    }
                    src={`${cmsUrl}${
                      homePage?.cards[3] && homePage?.cards[3].image?.url
                        ? homePage?.cards[3].image?.url
                        : ""
                    }`}
                  />
                </Link>

                <Link
                  href={
                    homePage?.cards[4]?.link !== null
                      ? `${homePage?.cards[4]?.link}`
                      : "/"
                  }
                  className="relative about-card  flex-grow h-[345px] md:h-[255px] md:basis-1/2 lg:basis-full "
                >
                  <AboutCardContent
                    variant="sm"
                    title={homePage?.cards[4] ? homePage?.cards[4].title : ""}
                    content={
                      homePage?.cards[4] ? homePage?.cards[4]["sub title"] : ""
                    }
                    src={`${cmsUrl}${
                      homePage?.cards[4] && homePage?.cards[4].image?.url
                        ? homePage?.cards[4].image?.url
                        : ""
                    }`}
                  />
                </Link>
              </div>
            </div>
          </div>
        </ParallaxWithFramer>
      )}
    </>
  );
}
